import { render, staticRenderFns } from "./current.vue?vue&type=template&id=65ce0854"
import script from "./current.vue?vue&type=script&lang=ts"
export * from "./current.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports